<template>
  <div class="fixed w-screen h-screen top-0 left-0  z-50">
    <div class="w-full h-full bg-black opacity-50" @click="$emit('close')"></div>
    <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white p-8 rounded-lg flex flex-col gap-4">
      <div class="flex items-center justify-between mb-6">
        <h2 class="text-2xl font-bold">{{ i18n.t('marketplace.general.language') }}</h2>
        <i class="bi bi-x-lg cursor-pointer text-xl" @click="$emit('close')"></i>
      </div>
      <div class="grid lg:grid-cols-3 gap-4">
        <div v-for="lang in languages" :key="lang.code" 
          @click="setLocale(lang.code); selectedLanguage = lang.code"
          class="flex gap-2 py-3 px-4 border-2 border-solid cursor-pointer bg-gray-100 rounded-lg text-sm" 
          :class="{
            '!border-black': selectedLanguage === lang.code,
            '!border-transparent': selectedLanguage !== lang.code
          }"
        >
          <img :src="`/images/marketplace/languages/${lang.code}.svg`" class="w-6 h-4 object-cover mt-1"/>
          <div>
            <div class="font-bold">{{ lang.name }}</div>
            <div class="text-sm text-gray-500">{{ lang.country }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      languages: [
        { code: 'cs', name: 'Čeština', country: 'Czechia' },
        { code: 'de', name: 'Deutsch', country: 'Deutschland' },
        { code: 'en', name: 'English', country: 'United States' },
        { code: 'es', name: 'Español', country: 'España' },
        { code: 'fr', name: 'Français', country: 'France' },
        { code: 'it', name: 'Italiano', country: 'Italia' },
      ],
      selectedLanguage: document.body.dataset.lang || 'en'
    };
  },
  methods: {
    setLocale(locale) {
      let url = window.location.pathname.split('/');
      if (document.body.dataset.lang) {
        url[1] = locale;
      } else {
        url.splice(1, 0, locale);
      } 
      window.location.href = url.join('/') + window.location.search;
    } 
  }
};
</script>